import {
  getConfirmPreviewPortalState,
  getPaymentSuccessPreviewPortalState,
  getReceiptPreviewPortalState,
  receiptPreviewQaAccountOverride,
  receiptPreviewQaPaymentPlansOverride,
} from './receiptPreviewData';

const STEPPER_KEY = 'Payments page step';
const CONFIRM_STEP_INDEX = 3;
const SUCCESS_STEP_INDEX = 4;
const SUCCESS_VARIANTS = new Set(['old', 'splash', 'frictionless', 'settlement']);

function mergePortalState(incoming) {
  const existing = JSON.parse(window.sessionStorage.getItem('soc-portal') || '{}');
  return {
    ...existing,
    ...incoming,
    account: { ...existing.account, ...incoming.account },
    paymentPlan: { ...existing.paymentPlan, ...incoming.paymentPlan },
    paymentMethod: { ...existing.paymentMethod, ...incoming.paymentMethod },
    settlementOffers: { ...existing.settlementOffers, ...incoming.settlementOffers },
    defaultSpecialPlan: { ...existing.defaultSpecialPlan, ...incoming.defaultSpecialPlan },
  };
}

/**
 * Run before any module that instantiates the store. Seeds session + mock overrides so
 * opening with `?receiptPreview=1` or `?confirmPreview=1` (and `MOCK_API=true` at build time)
 * shows those screens without logging in.
 *
 * - `/payment-plan?confirmPreview=1` — Confirm and pay
 * - `/payment-plan?receiptPreview=1` — payment-plan stepper success (in-flow receipt)
 * - `/payment-success?receiptPreview=1` — dedicated success page; optional `&variant=old|splash|frictionless|settlement` (default `old`)
 */
if (typeof window !== 'undefined' && process.env.MOCK_API === 'true') {
  const params = new URLSearchParams(window.location.search);
  if (params.get('confirmPreview') === '1' && window.location.pathname === '/payment-plan') {
    try {
      const next = mergePortalState(getConfirmPreviewPortalState());
      window.sessionStorage.setItem('soc-portal', JSON.stringify(next));
      window.__qaPaymentPlansOverride__ = receiptPreviewQaPaymentPlansOverride;
      window.__qaAccountOverride__ = receiptPreviewQaAccountOverride;
      const s = window.history.state || {};
      window.history.replaceState(
        {
          ...s,
          steppers: {
            ...(s.steppers || {}),
            [STEPPER_KEY]: CONFIRM_STEP_INDEX,
          },
        },
        '',
        '/payment-plan?confirmPreview=1'
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[confirmPreview] failed to apply payment-plan preview state', e);
    }
  } else if (params.get('receiptPreview') === '1' && window.location.pathname === '/payment-plan') {
    try {
      const next = mergePortalState(getReceiptPreviewPortalState());
      window.sessionStorage.setItem('soc-portal', JSON.stringify(next));
      window.__qaPaymentPlansOverride__ = receiptPreviewQaPaymentPlansOverride;
      window.__qaAccountOverride__ = receiptPreviewQaAccountOverride;
      const s = window.history.state || {};
      window.history.replaceState(
        {
          ...s,
          steppers: {
            ...(s.steppers || {}),
            [STEPPER_KEY]: SUCCESS_STEP_INDEX,
          },
        },
        '',
        '/payment-plan'
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[receiptPreview] failed to apply payment-plan preview state', e);
    }
  } else if (params.get('receiptPreview') === '1' && window.location.pathname === '/payment-success') {
    try {
      const rawVariant = params.get('variant') || 'old';
      const variant = SUCCESS_VARIANTS.has(rawVariant) ? rawVariant : 'old';
      const next = mergePortalState(getPaymentSuccessPreviewPortalState(variant));
      window.sessionStorage.setItem('soc-portal', JSON.stringify(next));
      window.__qaPaymentPlansOverride__ = receiptPreviewQaPaymentPlansOverride;
      window.__qaAccountOverride__ = receiptPreviewQaAccountOverride;
      const s = window.history.state || {};
      window.history.replaceState(s, '', '/payment-success');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[receiptPreview] failed to apply payment-success preview state', e);
    }
  }
}
